import { addTelemetryMetrics, noop, timeStampNow, elapsed } from '@datadog/browser-core';
export function startRecorderInitTelemetry(telemetry, observable) {
  if (!telemetry.metricsEnabled) {
    return {
      stop: noop
    };
  }

  var startContext;
  var documentReadyDuration;
  var recorderSettledDuration;

  var _observable$subscribe = observable.subscribe(function (event) {
    switch (event.type) {
      case 'start':
        startContext = {
          forced: event.forced,
          timestamp: timeStampNow()
        };
        documentReadyDuration = undefined;
        recorderSettledDuration = undefined;
        break;

      case 'document-ready':
        if (startContext) {
          documentReadyDuration = elapsed(startContext.timestamp, timeStampNow());
        }

        break;

      case 'recorder-settled':
        if (startContext) {
          recorderSettledDuration = elapsed(startContext.timestamp, timeStampNow());
        }

        break;

      case 'aborted':
      case 'deflate-encoder-load-failed':
      case 'recorder-load-failed':
      case 'succeeded':
        // Only send metrics for the first attempt at starting the recorder.
        unsubscribe();

        if (startContext) {
          // monitor-until: 2026-07-01
          addTelemetryMetrics("Recorder init metrics"
          /* TelemetryMetrics.RECORDER_INIT_METRICS_TELEMETRY_NAME */
          , {
            metrics: createRecorderInitMetrics(startContext.forced, recorderSettledDuration, elapsed(startContext.timestamp, timeStampNow()), event.type, documentReadyDuration)
          });
        }

        break;
    }
  }),
      unsubscribe = _observable$subscribe.unsubscribe;

  return {
    stop: unsubscribe
  };
}

function createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
  return {
    forced: forced,
    loadRecorderModuleDuration: loadRecorderModuleDuration,
    recorderInitDuration: recorderInitDuration,
    result: result,
    waitForDocReadyDuration: waitForDocReadyDuration
  };
}